import { Link, useLocation, useNavigate } from "react-router-dom";
import { NavDropdown } from "react-bootstrap";
import { navigationItems } from "../navigation";
import { canAccessNavigationItem, getRoleCodes, isProjectManager } from "../auth/roles";

function getNavigationLabelText(label) {
  return Array.isArray(label) ? label.join(" ") : label;
}

function renderNavigationLabel(label) {
  if (!Array.isArray(label)) return label;

  return (
    <span className="d-inline-flex flex-column lh-sm text-center">
      {label.map((line) => (
        <span key={line}>{line}</span>
      ))}
    </span>
  );
}

function Navbar({ user, onLogout, checkAuth, onChangePassword }) {
  const navigate = useNavigate();
  const location = useLocation();
  const roleCodes = getRoleCodes(user);
  const isPm = isProjectManager(user);
  const roleLabel = roleCodes.length <= 1 ? "Role" : "Roles";
  const roleValue = roleCodes.length ? roleCodes.join(", ") : "USR";

  const handleProtectedNav = async (path) => {
    const ok = await checkAuth();

    if (ok) {
      navigate(path);
    }
  };
  const isPlainLeftClick = (event) => (
    event.button === 0 &&
    !event.altKey &&
    !event.ctrlKey &&
    !event.metaKey &&
    !event.shiftKey
  );

  const handleInternalNavClick = (event, path) => {
    if (!isPlainLeftClick(event)) return;

    event.preventDefault();
    handleProtectedNav(path);
  };

  const renderNavigationItem = (item) => {
    if (!canAccessNavigationItem(user, item)) return null;

    const labelText = getNavigationLabelText(item.label);
    const renderedLabel = renderNavigationLabel(item.label);

    if (item.children) {
      const visibleChildren = item.children.filter((child) => canAccessNavigationItem(user, child));

      if (!visibleChildren.length) return null;

      return (
        <li className="nav-item" key={labelText}>
          <NavDropdown
            title={renderedLabel}
            id={`${labelText.toLowerCase().replace(/\s+/g, "-")}-nav-dropdown`}
            menuVariant="light"
          >
            {visibleChildren.map((child) => (
              child.href ? (
                <NavDropdown.Item
                  key={child.href}
                  href={child.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {child.label}
                </NavDropdown.Item>
              ) : (
                <NavDropdown.Item
                  key={child.path}
                  href={child.path}
                  onClick={(event) => handleInternalNavClick(event, child.path)}
                >
                  {child.label}
                </NavDropdown.Item>
              )
            ))}
          </NavDropdown>
        </li>
      );
    }

    return (
      <li className="nav-item" key={item.path}>
        <a
          className="nav-link"
          href={item.path}
          onClick={(event) => handleInternalNavClick(event, item.path)}
        >
          {renderedLabel}
        </a>
      </li>
    );
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-success">
      <div className="container">

        {/* LEFT */}
          {user && (
             <ul className="navbar-nav me-auto align-items-center">
              {navigationItems.map(renderNavigationItem)}
            </ul>
          )}

        {/* RIGHT */}
        <ul className="navbar-nav ms-auto align-items-center">

          {!user && (
            <li className="nav-item">
              <Link to="/" state={location.state} className="nav-link">Log-in</Link>
            </li>
          )}

          {user && (
            <>
              <li className="nav-item">
                <span className="navbar-text me-3">
                  Logged as <strong>{user.name}</strong>
                  {" | "}
                  {roleLabel} <strong>{roleValue}</strong>
                </span>
              </li>

              {!isPm && (
                <li className="nav-item">
                  <button
                    type="button"
                    onClick={onChangePassword}
                    className="btn btn-sm btn-outline-light me-3"
                  >
                    Change password
                  </button>
                </li>
              )}

              <li className="nav-item">
                <button
                  type="button"
                  onClick={onLogout}
                  className="btn btn-link nav-link p-0"
                >
                  Log-out
                </button>
              </li>
            </>
          )}

        </ul>

      </div>
    </nav>
  );
}

export default Navbar;
